// extracted by mini-css-extract-plugin
export default {"container":"SinglePLan_container__wYtOp","lessons":"SinglePLan_lessons__P3Qy5"};